// extracted by mini-css-extract-plugin
export var cardTitle = "_jo-1";
export var commentBubble = "_jo-e";
export var commentForm = "_jo-a";
export var commentInput = "_jo-b";
export var commentLabel = "_jo-d";
export var commentPrompt = "_jo-9";
export var csatCard = "_jo-0";
export var feedbackSection = "_jo-7";
export var starDisabled = "_jo-6";
export var starEmpty = "_jo-5";
export var starFilled = "_jo-4";
export var starWrapper = "_jo-3";
export var starsContainer = "_jo-2";
export var submittedComment = "_jo-c";
export var thankYouText = "_jo-8";